// Copyright 2019, White Label Communications, LLC, All rights reserved.

import { connect } from 'react-redux';
import BillingHistory from './BillingHistory';

function mapDispatchToProps() {
  return {};
}

export default connect(
  null,
  mapDispatchToProps,
)(BillingHistory);
